// extracted by mini-css-extract-plugin
module.exports = {"body":"_mechanicGaragePages__body__Gp5eh"};